import { ENV_CONFIG } from 'config/environment';

const baseImgUrl = `${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/press_logos`;
const logoUrlTime = `${baseImgUrl}/Time_Magazine_logo.png`;
const logoUrlCampaignsElections = `${baseImgUrl}/Campaigns___Elections.jpg`;
const logoUrlNYT = `${baseImgUrl}/The_New_York_Times_logo.png`;
const logoPolitico = `${baseImgUrl}/POLITICO_logo.png`;
const logoBloomberg = `${baseImgUrl}/bloomberg.svg`;
const logoNewYorkMag = `${baseImgUrl}/New_York_Magazine_Logo.svg`;

const pressLogos = [
  logoUrlCampaignsElections,
  logoNewYorkMag,
  logoUrlTime,
  logoUrlNYT,
  logoPolitico,
  logoBloomberg,
];
const pressLogosDouble = [...pressLogos, ...pressLogos];

export const PressSection = () => {
  return (
    <div className="press-section-container">
      <div className="row justify-around align-center">
        <span className="eyebrow-text color-inkBlue">Oath has been featured in...</span>
      </div>
      <div className="ticker-wrap">
        <div className="ticker">
          <div className="row">
            {[1, 2].map((value, index) => (
              <div
                className={`row justify-between align-center item-collection-${value}`}
                key={index}
              >
                {pressLogosDouble.map((logoSrc, index) => (
                  <img key={index} className="item" src={logoSrc} alt="Press Logo" />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
